import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: true,
    default: "dark",
    themes: {
      dark: {
        primary: "#a9a9a9",
        secondary: "#808080",
        accent: "#5AA8FF",
        anchor: "#5AA8FF",
      },
    },
  },
});
